export default "__VITE_ASSET__DU2_agJM__"